// extracted by mini-css-extract-plugin
export default {"select":"CodeTypeSelector_select__sZPUy"};